var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0833 12.5534V24.4271C32.0834 25.6377 31.6202 26.8025 30.7888 27.6825C29.9574 28.5624 28.8207 29.0909 27.612 29.1594L27.3437 29.1667H7.65621C6.44559 29.1668 5.28083 28.7036 4.40087 27.8722C3.52091 27.0408 2.99246 25.9041 2.92392 24.6955L2.91663 24.4271V12.5534L16.9925 19.9267C17.1491 20.0087 17.3232 20.0516 17.5 20.0516C17.6767 20.0516 17.8509 20.0087 18.0075 19.9267L32.0833 12.5534ZM7.65621 5.83337H27.3437C28.5185 5.83323 29.6515 6.26941 30.5229 7.05731C31.3944 7.8452 31.9421 8.92866 32.06 10.0975L17.5 17.7246L2.93996 10.0975C3.05301 8.97508 3.56274 7.92975 4.37751 7.14947C5.19228 6.36918 6.25866 5.90511 7.38496 5.84067L7.65621 5.83337H27.3437H7.65621Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.58daec162a6389d179d883249fa9d5c0.svg";
export { ForwardRef as ReactComponent };